import { combineReducers } from 'redux';
import { firebaseReducer } from 'react-redux-firebase';
import { firestoreReducer } from 'redux-firestore';
import ui from './ui';
import app from './app';

export default combineReducers({
  firebase: firebaseReducer,
  firestore: firestoreReducer,
  app,
  ui,
});
